module.exports = __webpack_public_path__ + "img/walogo.ae3e2fe2.svg";